import { useCallback } from 'react';

export default function useFormatBytes(bytes: number): () => string {
  return useCallback(() => {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const octetSize = 1024;
    const sizes = ['Bytes', 'Ko', 'Mo', 'Go', 'To', 'Po', 'Eo', 'Zo', 'Yo'];

    const puissance = Math.floor(Math.log(bytes) / Math.log(octetSize));

    return `${bytes / Math.pow(octetSize, puissance)} ${sizes[puissance]}`;
  }, [bytes]);
}
